import Breadcrumbs from "components/Common/Breadcrumb"
import { ErrorMessage, Field, Formik, Form } from "lib/formik"
import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardTitle, Col, Row } from "reactstrap"
import Select from "react-select"
import { useSelector } from "react-redux"
import { useLocation, useNavigate } from "react-router-dom"
import { useDispatch } from "react-redux"
import {
  addBulkCoupon,
  getAllCouponsGroupsList,
  getAllPromotionsList,
} from "store/actions/promotionsAction"
import Switch from "components/Shared/Switch"
import "rsuite/dist/rsuite.min.css"
import { DatePicker } from "rsuite"
import { showAlert } from "store/reducers/alertReducer"
import {
  sanitizeAlphanumeric,
  wholeNumberInputProps,
} from "components/Common/couponFormInputUtils"
import {
  addBulkCouponSchema,
  BULK_COUPON_PREFIX_MAX_LENGTH,
} from "components/Common/validation"
import { getBulkCouponPrefixMaxLengthMessage } from "components/Common/validationMessages"
import isPermissionEnabled from "common/isPermissionEnabled"
import isBefore from "date-fns/isBefore"
import couponBulkUploadTemplate from "assets/file/couponBulkUploadTemplate.csv"
import { startOfDay } from "date-fns"
import { useTranslation } from "react-i18next"
import TextError from "components/Shared/TextError"
import TranslatedFileInput from "components/Shared/TranslatedFileInput"

const initialValues = {
  name: "",
  nameAr: "",
  promotion: null,
  couponGroup: null,
  hasUpload: false,
  file: "",
  prefix: "",
  noOfDigits: null,
  noOfCodes: null,
  allowInfiniteUsage: false,
  maxUsage: 1,
  startsAt: "",
  expiresAt: "",
}

const AddBulkCoupon = () => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  document.title = t(`Add Bulk Coupon `)

  const location = useLocation()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [formValues, setFormValues] = useState(initialValues)

  const {
    promotionsList,
    couponDetails,
    loading,
    couponsGroupsList,
    isLoading,
  } = useSelector(state => state.Promotions)

  const { userRole, accountType } = useSelector(state => state.Login)

  const [usersPermissions, setUsersPermissions] = useState({
    create: null,
  })

  // FIRST CHECK PERMISSION, IF DOES'T HAVE THEN REDIRECT TO DASHBOARD
  useEffect(() => {
    const isPermissionCreate = isPermissionEnabled(
      userRole,
      14,
      "promotion_2",
      accountType
    )

    if (!isPermissionCreate) {
      navigate("/dashboard")
    }
    setUsersPermissions({
      create: isPermissionCreate,
    })
  }, [userRole])

  useEffect(() => {
    const fetchPromotionsList = () => {
      dispatch(getAllPromotionsList())
    }
    const fetchCouponsGroupsList = () => {
      dispatch(getAllCouponsGroupsList())
    }
    fetchPromotionsList()
    fetchCouponsGroupsList()
  }, [])

  const handleOnSubmit = values => {
    const {
      name,
      nameAr,
      promotion,
      couponGroup,
      hasUpload,
      file,
      prefix,
      noOfDigits,
      allowInfiniteUsage,
      maxUsage,
      noOfCodes,
      startsAt,
      expiresAt,
    } = values

    const updatedCouponGroupId = couponGroup.value
    const updatedPromotionId = promotion.value

    const updatedHasUpload = hasUpload === "FILE" || hasUpload ? true : false

    let data = new FormData()
    data.append("name", name)
    data.append("nameAr", nameAr)
    data.append("startsAt", startsAt)
    data.append("expiresAt", expiresAt)
    data.append("promotion", updatedPromotionId)
    data.append("couponGroup", updatedCouponGroupId)
    data.append("allowInfiniteUsage", allowInfiniteUsage)
    data.append("maxUsage", maxUsage)
    data.append("hasUpload", updatedHasUpload)
    if (updatedHasUpload) {
      data.append("file", file)
    } else {
      data.append("prefix", prefix)
      data.append("noOfDigits", noOfDigits)
      data.append("noOfCodes", noOfCodes)
    }

    dispatch(addBulkCoupon(data))
      .then(action => {
        const { statusCode, status, msg } = action?.payload
        if (statusCode === 200 && status) {
          dispatch(showAlert({ text: msg, type: "success" }))
          navigate(`/coupons`)
        } else {
          dispatch(showAlert({ text: msg, type: "error" }))
        }
      })
      .catch(error => {})
  }

  return (
    <div className="page-content">
      <div className="container-fluid add_coupon_section">
        <Breadcrumbs />
        <Row>
          <Col xl={12}>
            <Card>
              <CardBody>
                <CardTitle>{t("Generate Bulk Coupon")}</CardTitle>
                <Formik
                  initialValues={formValues}
                  enableReinitialize={true}
                  validationSchema={addBulkCouponSchema()}
                  onSubmit={handleOnSubmit}
                >
                  {({ values, setFieldValue, errors, touched }) => (
                    <Form>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(English)")}
                            </label>
                            <Field
                              type="text"
                              id="name"
                              name="name"
                              placeholder={t("Name(English)")}
                              className={`form-control ${
                                touched.name && errors.name ? "is-invalid" : ""
                              }`}
                            />
                            <TextError name="name" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="name">
                              <span className="text-danger">*</span>{" "}
                              {t("Name(عربي)")}
                            </label>
                            <Field
                              type="text"
                              id="nameAr"
                              name="nameAr"
                              placeholder={t("Name(عربي)")}
                              className={`form-control ${
                                touched.nameAr && errors.nameAr
                                  ? "is-invalid"
                                  : ""
                              }`}
                              style={{ direction: "rtl" }}
                            />
                            <TextError name="nameAr" />
                          </div>
                        </div>

                        <div className="col-lg-6 mt-2">
                          <label htmlFor="">
                            <span className="text-danger">*</span>{" "}
                            {t("Select Coupon Group")}
                          </label>
                          <Select
                            value={values.couponGroup}
                            onChange={selectedValue => {
                              setFieldValue("couponGroup", selectedValue)
                            }}
                            options={couponsGroupsList?.map(item => ({
                              label:
                                language === "sa" ? item.nameAr : item.name,
                              value: item._id,
                            }))}
                            placeholder={t("Select Coupon Group")}
                            className={`select2-selection ${
                              touched.couponGroup && errors.couponGroup
                                ? "danger_color_border"
                                : ""
                            } `}
                          />
                          <TextError name="couponGroup" />
                        </div>

                        <div className="col-lg-6 mt-2">
                          <label htmlFor="">
                            <span className="text-danger">*</span>{" "}
                            {t("Select Discount")}
                          </label>
                          <Select
                            value={values.promotion}
                            onChange={selectedValue => {
                              setFieldValue("promotion", selectedValue)
                            }}
                            options={promotionsList?.map(item => ({
                              label: item.name,
                              value: item._id,
                            }))}
                            placeholder={t("Select Discount")}
                            className={`select2-selection ${
                              touched.promotion && errors.promotion
                                ? "danger_color_border"
                                : ""
                            } `}
                          />
                          <TextError name="promotion" />
                        </div>
                        <div className="col-lg-12">
                          <div className="row">
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="allowInfiniteUsage">
                                  {t("Allow Infinite Usage")}
                                </label>
                                <Switch
                                  isChecked={values.allowInfiniteUsage}
                                  onClickHandler={() => {
                                    //     setFieldValue(
                                    //       "allowInfiniteUsage",
                                    //       !values.allowInfiniteUsage
                                    //     )
                                    //   }}
                                    // onClickHandler={() => {
                                    setFieldValue(
                                      "allowInfiniteUsage",
                                      !values.allowInfiniteUsage
                                    )
                                    if (values.allowInfiniteUsage) {
                                      setFieldValue("maxUsage", 1)
                                    }
                                  }}
                                />
                              </div>
                            </div>
                            {!values.allowInfiniteUsage && (
                              <div className="col-lg-6">
                                <div className="form_field">
                                  <label htmlFor="maxUsage">
                                    <span className="text-danger">*</span>{" "}
                                    {t("Max Usage")}
                                  </label>
                                  <Field
                                    type="number"
                                    id="maxUsage"
                                    name="maxUsage"
                                    placeholder={t("Max Usage")}
                                    className={`form-control ${
                                      touched.maxUsage && errors.maxUsage
                                        ? "is-invalid"
                                        : ""
                                    }`}
                                    {...wholeNumberInputProps}
                                  />
                                  <TextError name="maxUsage" />
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field bulk_start_date">
                            <label htmlFor="startsAt">
                              <span className="text-danger">*</span>{" "}
                              {t("Start Date & Time")}
                            </label>
                            <DatePicker
                              showTime={{ format: "HH:mm" }} // Show time picker
                              format="yyyy-MM-dd HH:mm" // Custom format for displaying date and time
                              onChange={value => {
                                setFieldValue("startsAt", value)
                              }}
                              value={values.startsAt}
                              shouldDisableDate={date =>
                                isBefore(
                                  startOfDay(date),
                                  startOfDay(new Date())
                                )
                              }
                              placement="autoVerticalStart"
                              placeholder="2024-07-16 14:30"
                            />

                            <TextError name="startsAt" />
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="form_field bulk_end_date">
                            <label htmlFor="endTime">
                              <span className="text-danger">*</span>{" "}
                              {t("End Date & Time")}
                            </label>
                            <DatePicker
                              showTime={{ format: "HH:mm" }}
                              format="yyyy-MM-dd HH:mm"
                              onChange={value => {
                                setFieldValue("expiresAt", value)
                              }}
                              value={values.expiresAt}
                              shouldDisableDate={date =>
                                isBefore(
                                  startOfDay(date),
                                  startOfDay(new Date())
                                )
                              }
                              placement="autoVerticalStart"
                              placeholder=" 2024-07-20 14:30"
                            />

                            <TextError name="expiresAt" />
                          </div>
                        </div>

                        {!values.hasUpload && (
                          <>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="prefix">
                                  <span className="text-danger">*</span>{" "}
                                  {t("Prefix")}{" "}
                                  <span className="text-muted">
                                    ({getBulkCouponPrefixMaxLengthMessage(BULK_COUPON_PREFIX_MAX_LENGTH)})
                                  </span>
                                </label>
                                <Field
                                  type="text"
                                  id="prefix"
                                  name="prefix"
                                  maxLength={BULK_COUPON_PREFIX_MAX_LENGTH}
                                  placeholder={t("Prefix")}
                                  className={`form-control ${
                                    touched.prefix && errors.prefix
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  onChange={e => {
                                    setFieldValue(
                                      "prefix",
                                      sanitizeAlphanumeric(
                                        e.target.value,
                                        BULK_COUPON_PREFIX_MAX_LENGTH
                                      )
                                    )
                                  }}
                                />
                                <TextError name="prefix" />
                              </div>
                            </div>
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="noOfDigits">
                                  <span className="text-danger">*</span>{" "}
                                  {t("Number Of Digits")}
                                </label>
                                <Field
                                  type="number"
                                  id="noOfDigits"
                                  name="noOfDigits"
                                  placeholder={t("Number Of Digits")}
                                  className={`form-control ${
                                    touched.noOfDigits && errors.noOfDigits
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  {...wholeNumberInputProps}
                                  min={3}
                                  max={10}
                                />
                                <TextError name="noOfDigits" />
                              </div>
                            </div>
                            {/* {console.log(errors)} */}
                            <div className="col-lg-6">
                              <div className="form_field">
                                <label htmlFor="noOfCodes">
                                  <span className="text-danger">*</span>{" "}
                                  {t("Number of Codes to Generate")}
                                </label>
                                <Field
                                  type="number"
                                  id="noOfCodes"
                                  name="noOfCodes"
                                  placeholder={t("Number of Codes to Generate")}
                                  className={`form-control ${
                                    touched.noOfCodes && errors.noOfCodes
                                      ? "is-invalid"
                                      : ""
                                  }`}
                                  {...wholeNumberInputProps}
                                  max={1000}
                                />
                                <TextError name="noOfCodes" />
                              </div>
                            </div>
                          </>
                        )}

                        <div className="col-lg-6">
                          <div className="form_field">
                            <label htmlFor="hasUpload">{t("Upload CSV")}</label>
                            <div className="d-flex align-items-center">
                              <Switch
                                isChecked={values.hasUpload}
                                onClickHandler={() => {
                                  setFieldValue("hasUpload", !values.hasUpload)
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        {(values.hasUpload === "FILE" || values.hasUpload) && (
                          <div className="col-lg-6">
                            <div className="form_field">
                              <label htmlFor="imageFile">
                                <span className="text-danger">* </span>
                                {t("Upload Coupons")}
                              </label>
                              <div className="d-flex align-items-center">
                                <TranslatedFileInput
                                  id="file"
                                  name="file"
                                  accept=".csv,text/csv"
                                  invalid={Boolean(touched.file && errors.file)}
                                  onChange={e => {
                                    const selectedFile = e.currentTarget.files[0]
                                    if (
                                      selectedFile &&
                                      !selectedFile.name.toLowerCase().endsWith(".csv")
                                    ) {
                                      setFieldValue("file", "")
                                      e.currentTarget.value = ""
                                      dispatch(
                                        showAlert({
                                          text: t(
                                            "Invalid file format. Please upload a valid CSV file."
                                          ),
                                          type: "error",
                                        })
                                      )
                                      return
                                    }
                                    setFieldValue("file", selectedFile || "")
                                  }}
                                />
                                {values.hasUpload && (
                                  <Button
                                    color="primary"
                                    className="ms-3"
                                    style={{ whiteSpace: "nowrap" }}
                                    type="button"
                                  >
                                    <a
                                      href={couponBulkUploadTemplate}
                                      download="CSV template.csv"
                                      className="text-white"
                                    >
                                      {t("Download CSV template")}
                                    </a>
                                  </Button>
                                )}
                              </div>
                              <TextError name="file" />
                            </div>
                          </div>
                        )}

                        <div className="col-12 d-flex justify-content-end mt-2 ">
                          <Button
                            type="button"
                            className="mx-2"
                            color="secondary"
                            onClick={() => navigate(-1)}
                          >
                            {t("Cancel")}
                          </Button>
                          <Button
                            type="submit"
                            color="success"
                            disabled={isLoading}
                            className="w_fit_content"
                          >
                            {t("Add")}
                          </Button>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}

export default AddBulkCoupon
